export default "__VITE_ASSET___AEVuzHf__"